import type { Registry as Services } from '@ember/service';
import {
  createIntl as createReactIntl,
  createIntlCache,
  type IntlShape,
} from 'react-intl';

/**
 * ember-intl never exposes its messages to drop into a regular `IntlProvider`,
 * so rather than hand react-intl a catalog, map its helpers straight onto
 * ember-intl's. Only `formatMessage` (and so `<FormattedMessage>`) for now.
 */
export default function createIntl(intl: Services['intl']): IntlShape {
  const base = createReactIntl(
    { locale: intl.primaryLocale ?? 'en' },
    createIntlCache(),
  );
  return {
    ...base,
    formatMessage: (({ id }, values): string =>
      intl.t(
        String(id),
        values as Parameters<Services['intl']['t']>[1],
      )) as IntlShape['formatMessage'],
  };
}
